import { useEffect } from 'react';
import { useToast } from './useToast';

/**
 * Use as the third `enabled` argument with async `status` objects so
 * in-progress (loading) messages never become toasts — buttons/spinners carry that.
 */
export function shouldToastStatus(status) {
  if (!status?.message) {
    return false;
  }
  return status.state !== 'loading';
}

/**
 * Queues a global toast when `message` is non-empty and `enabled` is true.
 * Use instead of inline `<Notice>` so feedback appears above modals.
 */
export function useMessageToast(message, variant = 'info', enabled = true) {
  const { showToast } = useToast();
  useEffect(() => {
    if (!enabled || !message) {
      return;
    }
    showToast(message, variant || 'info');
  }, [message, variant, enabled, showToast]);
}
